import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const StageTable = (props) => {

    const { user } = useSelector(state => state.auth)
    const [stageList, setStageList] = useState([]);

    useEffect(() => {
        // console.log(props, 'data ')
        if (props.stages) {
            setStageList(props?.stages)
        }
    }, [props?.stages]);

    return (
        <>
            <h5 className='py-3'><strong>Current Stages</strong></h5>
            <table className="table table-hover table-custom mb-0">
                <thead className="">
                    <tr>
                        <th>#</th>
                        <th>Timeline Manager</th>
                        <th>Stage</th>
                        <th>Owner Name</th>
                        <th>Approver Name</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        stageList && stageList.map((stage, index) => (
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{stage?.strategist_name || 'N/A'}</td>
                                <td>{stage?.strategy || 'N/A'}</td>
                                {/* <td>{moment(stage?.due_date).format('DD/MM/YYYY')}</td> */}
                                <td>{stage?.owner_name || 'N/A'}</td>
                                <td>{stage?.approver_name || 'N/A'}</td>
                                <td>{stage?.status || 'N/A'}</td>
                                <td>
                                    { stage?.strategist_user_id === user.user_id
                                     ? <button className="btn btn-sm round custom-btn-outline-info mx-1" onClick={() => props.handdelUpdate(stage)}><i className='fa fa-edit'></i></button> : null} 
                                    { stage?.strategist_user_id === user.user_id ? <button className="btn btn-sm round btn-outline-danger" onClick={() => props.deleteTimelineModalShow(stage, 'Stage')}>Delete</button> : null }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            {!stageList.length ? <div className='text-center font-weight-bold pt-3'>No Records</div> : null}
        </>
    );
};
export default StageTable;